class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search-suggestions');
    this.predictiveSearchManualSuggestions = this.querySelector('#predictive-search-manual-suggestions');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.input.addEventListener('focus', this.debounce((event) => {
      const searchTerm = this.input.value.trim();

      if (!searchTerm.length) {
        this.openManualSuggestions();
      } else {
        this.getSearchResults(searchTerm);
      }
      
    }, 300).bind(this));

    // this.input.addEventListener('blur', this.debounce((event) => {
    //   this.closeManualSuggestions();
    // }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.openManualSuggestions();
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[type]=query,product,collection,page,article&resources[options][fields]=body,product_type,tag,title,variants.barcode,variants.sku,variants.title,vendor`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.closeManualSuggestions();
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.setAttribute('style', 'display: block !important');
  }

  close() {
    this.predictiveSearchResults.setAttribute('style', 'display: none !important');
  }

  openManualSuggestions() {
    this.predictiveSearchManualSuggestions.style.display = 'block';
  }

  closeManualSuggestions() {
    this.predictiveSearchManualSuggestions.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);